import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { ChevronDown } from 'lucide-react';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const SMSCampaignMetrics = () => {
  const [selectedDeal, setSelectedDeal] = useState('all');
  const [deals] = useState([
    { id: 'all', name: 'All Deals' },
    { id: 'deal1', name: 'Summer Sale 2023' },
    { id: 'deal2', name: 'Flash Deals' },
    { id: 'deal3', name: 'Xmas Promo' },
  ]);

  const [durations] = useState([
    "first",
    "second",
    "third",
    "fourth"
  ]);
  const [selectedDuration, setSelectedDuration]= useState("first");

  const FirstQuarter = ['January', 'February', 'March'];
  const SecondQuarter =  ['April', 'May', 'June'];
  const ThirdQuarter = ['July', 'August', 'September'];
  const FourthQuarter = ['October', 'November', 'December'];

  // Sample data for each weekly, Monthly and Quarterly labels
  const dealData = {
    all: {
      first: [70, 80, 50], 
      second: [65, 75, 85],
      third: [15, 85, 55], 
      fourth: [80, 90, 100],
    },
    deal1: {
      first: [70, 80, 50],   
      second: [65, 75, 85],  
      third: [15, 85, 55],   
      fourth: [80, 90, 100],  
    },
    deal2: {
      first: [60, 70, 40],   
      second: [55, 65, 75],  
      third: [20, 80, 60],   
      fourth: [70, 80, 90],  
    },
    deal3: {
      first: [75, 85, 55],   
      second: [60, 70, 80],  
      third: [25, 90, 65],   
      fourth: [85, 95, 105]
    },
  };

  const chartData = {
    labels: selectedDuration === "first" ? FirstQuarter 
    : selectedDuration === "second" ? SecondQuarter 
    : selectedDuration==="third"? ThirdQuarter 
    : FourthQuarter, 
    datasets: [
      {
        label: 'CAMPAIGNS',
        data: dealData[selectedDeal][selectedDuration],
        borderColor: '#FF6B6B',
        backgroundColor: 'rgba(255, 107, 107, 0.5)',
        tension: 0.4,
        borderWidth:2,
        fill: true,
        borderRadius:10
      }
    ]
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    beginAtZero: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          callback: (value) => `${value}%`,
          font: {
            size: window.innerWidth < 768 ? 10 : 12
          }
        },
        grid: {
          display: false
        }
      },
      x: {
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          font: {
            size: window.innerWidth < 768 ? 10 : 12
          }
        },
        grid: {
          display:false
        }
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    barThickness: 100,
    barPercentage: 0.5,
    categoryPercentage: 0.8,
  };


  return (
        <div className="col-span-12 p-4 bg-white rounded-2xl shadow-xl lg:col-span-8 md:p-6">
          <div className="flex flex-col gap-4 justify-between mb-6 md:flex-row md:items-center">
            <h2 className="text-lg font-semibold text-gray-800 md:text-sm">SMS Campaigns</h2>
            <div className="flex flex-wrap gap-3">
              <div className="relative flex-1 md:flex-none">
                <select
                  value={selectedDeal}
                  onChange={(e) => setSelectedDeal(e.target.value)}
                  className="w-full md:w-auto appearance-none pl-4 pr-10 py-2.5 text-sm bg-white rounded-xl border-2 border-pink-100 
                    text-gray-700 font-medium hover:border-pink-200 focus:border-pink-300 focus:ring-2 
                    focus:ring-pink-100 focus:outline-none transition-all cursor-pointer min-w-[120px] max-w-[120px]
                    shadow-sm hover:shadow-md"
                >
                  {deals.map((deal) => (
                    <option 
                      key={deal.id} 
                      value={deal.id}
                      className="py-2 text-gray-700"
                    >
                      {deal.name}
                    </option>
                  ))}
                </select>
                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <ChevronDown size={16} className="text-pink-400" />
                </div>
                <div className="absolute top-0 bottom-0 left-0 w-1 bg-gradient-to-b from-pink-400 to-pink-500 rounded-l-xl" />
              </div>
              <div className="relative flex-1 md:flex-none">
                <select
                  value={selectedDuration}
                  onChange={(e) => setSelectedDuration(e.target.value)}
                  className="w-full md:w-auto appearance-none pl-4 pr-10 py-2.5 text-sm bg-white rounded-xl border-2 border-pink-100 
                    text-gray-700 font-medium hover:border-pink-200 focus:border-pink-300 focus:ring-2 
                    focus:ring-pink-100 focus:outline-none transition-all cursor-pointer min-w-[120px] max-w-[120px]
                    shadow-sm hover:shadow-md"
                >
                  {durations.map((period, index) => (
                    <option 
                      key={index} 
                      value={period}
                      className="py-2 text-gray-700"
                    >
                      {period === "first" ? "1st Quarter" : period === "second" ? "2nd Quarter" : period === "third" ? "3rd Quarter" :"4th Quarter"}
                    </option>
                  ))}
                </select>
                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                  <ChevronDown size={16} className="text-pink-400" />
                </div>
                <div className="absolute top-0 bottom-0 left-0 w-1 bg-gradient-to-b from-pink-400 to-pink-500 rounded-l-xl" />
              </div>
            </div>
          </div>
          <div className="h-[250px] md:h-[400px]">
            <Bar 
              data={chartData} 
              options={options}
            />
          </div>
        </div>

  );
};

export default SMSCampaignMetrics;